// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Ox4Xg","avatar":"styles_avatar__FrZOV","status":"styles_status__qZ8zj"};